import React, { useState, useEffect, forwardRef, useRef, useMemo, Fragment } from "react";
import ttAPI from '../../api/ttAPI';
import { Grid, FormLabel, FormGroup, FormControlLabel, Switch, CircularProgress,
         TextField, InputAdornment, Input, FormControl, InputLabel, Box,
         IconButton, NativeSelect, Select, ListSubheader, MenuItem, Menu,
         TableRow, TableCell, ListItemIcon, ListItemText, Chip, Button, Tooltip,
       } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker as MaterialDatePicker} from '@material-ui/pickers';
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';
// components
import PageTitle from "../../components/PageTitle";
import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import DateFnsUtils from '@date-io/date-fns';
import config from '../../config';
import classnames from "classnames";
import {
    CalendarToday as CalendarTodayIcon,
    Search as SearchIcon,
    Clear as ClearIcon,
    Email as EmailIcon,
    MoreVert as MoreVertIcon,
    CloudDownload as CloudDownloadIcon,
    Room as RoomIcon,
    VpnKey as VpnKeyIcon,
    TrackChanges as TrackChangesIcon,
} from '@material-ui/icons'

import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import MultiSelectAutoComplete from '../../components/MultiSelectAutoComplete/MultiSelectAutoComplete';
import NearbyJobsDialog from "../../components/NearbyJobsDialog/NearbyJobsDialog";
import './Retests.css'
registerLocale('en-NZ', enNZ);

const Retests = forwardRef((props, ref) => {
  // global
  const classes = useStyles();
  const history = useHistory();

  // local
  var [data, setData] = useState([]);
  var [allRetestStatus, setAllRetestStatus] = useState([]);
  var [isRange, setIsRange] = useState(false);
  var [isTimeRangeInvalid, setIsTimeRangeInvalid] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var [from, setFrom] = useState();
  var [to, setTo] = useState();
  var [selectedFrom, setSelectedFrom] = useState(null);
  var [selectedTo, setSelectedTo] = useState(null);
  var [isLoading, setIsLoading] = useState(false);
  var [displayKeyValue, setDisplayKeyValue] = useState('');
  const delayedOnSearchKey = useRef(debounce(q => onSearchKey(q), 500)).current;
  // new filters start
  var [page, setPage] = useState(0);
  var [key, setKey] = useState('');
  var [count, setCount] = useState(0);
  var [selectedCustomers, setSelectedCustomers] = useState([]);
  var [selectedSites, setSelectedSites] = useState([]);
  var [customersSelectionUpdated, setCustomersSelectionUpdated] = useState(false);
  var [sitesSelectionUpdated, setSitesSelectionUpdated] = useState(false);
  var [selectedRegions, setSelectedRegions] = useState([]);
  var [selectedGeographicRegions, setSelectedGeographicRegions] = useState([]);
  var [selectedGeographicLocalities, setSelectedGeographicLocalities] = useState([]);
  var [selectedStatuses, setSelectedStatuses] = useState([]);
  var [selectedArchived, setSelectedArchived] = useState(false);
  var [selectedAssetType, setSelectedAssetType] = useState('ALL');
  var [selectedKpiCustomer, setSelectedKpiCustomer] = useState(false);
  var [selectedKeyCustomer, setSelectedKeyCustomer] = useState(false);
  var [sortByColumn, setSortByColumn] = useState('');
  var [sortDirection, setSortDirection] = useState('');

  var [offset, setOffset] = useState(0);
  var [rowsPerPage, setRowsPerPage] = useState(100);

  var [cachedSelectedRetestRegions, setCachedSelectedRetestRegions] = useState(null);
  var [cachedSelectedGeographicRegions, setCachedSelectedGeographicRegions] = useState(null);
  var [cachedSelectedGeographicLocalities, setCachedSelectedGeographicLocalities] = useState(null);
  var [cachedSelectedCustomers, setCachedSelectedCustomers] = useState(null);
  var [cachedSelectedSites, setCachedSelectedSites] = useState(null);
  var [cachedSelectedRetestStatuses, setCachedSelectedRetestStatuses] = useState(null);
  //var [cachedSelectedAssetType, setCachedSelectedAssetType] = useState(null);
  // new filters end

  var [customersFilterOptions, setCustomersFilterOptions] = useState([]);
  var [sitesFilterOptions, setSitesFilterOptions] = useState([]);
  var [retestRegionsOptions, setRetestRegionsOptions] = useState([]);
  var [retestStatusOptions, setRetestStatusOptions] = useState([]);
  var [geoRegionsFilterOptions, setGeoRegionsFilterOptions] = useState([]);
  var [geoLocalitiesFilterOptions, setGeoLocalitiesFilterOptions] = useState([]);
  //var [assetTypeFilterOptions, setAssetTypeFilterOptions] = useState([]);// a small set list: ALL, AED,TELTAG not pulling from server at this stage, don't need this right now
  var [initFilterOptionsDone, setInitFilterOptionsDone] = useState(false);

  var [isEditingNotes, setIsEditingNotes] = useState(false);
  var [isEditingStatus, setIsEditingStatus] = useState(false);
  var [isEditingReminded, setIsEditingReminded] = useState(false);
  var [isEditingEmailTotalAssets, setIsEditingEmailTotalAssets] = useState(false);
  var [currentSelectedRemindedDate, setCurrentSelectedRemindedDate] = useState(null);
  var [statusOpen, setStatusOpen] = useState(false);

  // for checking nearby "jobs"
  const nearbyJobsDialogRef = useRef();

  // menu start
  var [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:focus': {
          backgroundColor: theme.palette.common.white
        },
      },
    }))(MenuItem);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  // menu end

  const columns = [

      { label: 'ID', name: 'id', options: {filter: false, display: false, download: false}},
      { label: 'Name', name: 'name', options: {download: true, filter: false}},
      { label: 'Site Name', name: 'site_name', options: {download: true,filter: false}},
      { label: 'Expiry Date', name: 'expiry_month', options: {filter: false,download: true}},
      { label: 'Last Tested', name: 'last_tested', options: {filter: false, download: true}},
      { label: 'Contact', name: 'site_contact', options: {filter: false, download: true}},
      { label: 'Phone', name: 'site_phone', options: {filter: false, download: true}},
      { label: 'Email', name: 'site_email', options: {filter: false, download: true}},
      { label: 'Assets', name: 'assets', options: {filter: false, download: true}},
      { label: 'Region', name: 'franchise_name', options: {filter: false, download: true}},
      { label: 'Geo Region', name: 'site_geo_region_name', options: {filter: false, download: true}},
      { label: 'Geo Locality', name: 'site_geo_locality', options: {filter: false, download: true}},
      { label: 'Notes', name: 'notes', options: {filter: false, download: true}},
      { label: 'Status', name: 'status', options: {filter: false, download: true}},
      { label: 'Reminded', name: 'date_reminded', options: {filter: false, download: true}},
      { label: 'Archived', name: 'archived', options: {filter: false, download: true, display: false }},
      { label: 'Book', name: 'book', options: {download: true, filter: false, display: false}},
      { label: 'Asset Type', name: 'asset_type', options: {download: true, filter: false, display: false}},
      {
        label: 'Action',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true,
        }
      }
  ];

 const getMuiTheme = () => createMuiTheme({
   palette: {
    primary: {
      main: '#FFCA06',
    },
  },
    overrides: {
      MuiTable: {
        root: {
          borderCollapse: 'inherit'
        }
      },
      MuiTableBody: {
        root: {
          borderCollapse: 'inherit'
        }
      },
      MUIDataTableFilter: {
        root: {
          width: '800px',
        }
      },
      MuiFormControlLabel: {
        root: {
          marginLeft: '0px !important'
        }
      },
      MuiTextField: {
        root: {
          width: '100px'
        }
      },
      MuiTableCell: {
          root: {
              padding: '0px 16px',
          },
          body: {
              color: 'inherit'
          }
      },
      MuiTableRow: {
        root: {
          '&$selected': {
            backgroundColor: 'rgba(25, 118, 210, 0.08) !important'
          }
        }
      },
      MUIDataTableToolbarSelect: {
         root: {
           visibility: 'hidden'
         }
      },
      MUIDataTableSelectCell: {
          root: {
            display: 'none'
          }
      },

    }
  });

  useEffect(() => {
      let mounted = true;

      async function fetchAllRetestStatus() {
          const response = await ttAPI.getAllUIRetestStatus();
          if (response !== undefined && response !== null) {
            if(mounted){
              if(response !== undefined && response !== null && response.length > 0) {
                  var temp = [];
                  //temp.push(<option key="" aria-label="None" value="" />);
                  //temp.push(<MenuItem key="0" value=""></MenuItem>);
                  /*response.forEach((status, index) => {

                    /*temp.push(<Fragment key={status.id}>
                        <option value={status.name} title={status.description}>{status.name}</option>
                        </Fragment>
                    );


                  });*/
                  var groupName = '';
                  response.forEach((status, index) => {
                      if (groupName !== status.category_name) {
                          groupName = status.category_name;
                          temp.push(<ListSubheader key={`${status.id}_head`}>{status.category_name}</ListSubheader>);
                      }
                    temp.push(<MenuItem key={status.id} value={status.value} title={status.description}
                                        className={classnames({
                                        [classes.doneText]: status.category_name === 'Done',
                                        [classes.inProgressText]: status.category_name === 'In Progress' && status.status !== 'NEW',
                                        [classes.actionRequiredText]: status.category_name === 'Action Required',
                                        [classes.onholdText]: status.category_name === 'On-hold',
                                        [classes.archivedText]: status.category_name === 'Archived',
                                        [classes.archivedTextStrikeThrough]: status.category_name === 'On-hold' && props.name === 'CLOSED/NO NEED'})}>
                                        {status.name}</MenuItem>);


                  });


                  setAllRetestStatus(temp);
                  setRetestStatusOptions(response);

                  if (localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
                      JSON.parse(localStorage.getItem('retests_filter_list'))[13] !== undefined &&
                      JSON.parse(localStorage.getItem('retests_filter_list'))[13] !== null) {
                        var cachedList = JSON.parse(localStorage.getItem('retests_filter_list'))[13];
                        setSelectedStatuses(cachedList);
                        setCachedSelectedRetestStatuses(
                            response.filter(option => cachedList.filter(value => value === option.id).length > 0));
                  }
                }
            }
          }
      }

      fetchAllRetestStatus();
      return () => mounted = false;
  },[]);

  useEffect(() => {
     let mounted = true;

     const fetchData = async() => {
          setIsLoading(true);
          setData([]);

          var fromDate = null;
          var toDate = null;

          if (from !== undefined && from !== null && !isNaN(from.getTime())) {
              var [date, month, year] = from.toLocaleDateString('en-NZ').split("/");
              fromDate = `${year}-${month}-${date}`;
          }

          if (to !== undefined && to !== null && !isNaN(to.getTime())) {
              var [date, month, year] = to.toLocaleDateString('en-NZ').split("/");
              toDate = `${year}-${month}-${date}`;
          }

          if (key !== undefined && key !== null && key !== '' && key.length >= 3) {
              setPage(0);
              setOffset(0);
            }
          //console.log('[fetchData]before fetch data', from, to, fromDate, toDate);
          const response = await ttAPI.getRetests(
            key, offset, rowsPerPage, selectedCustomers, selectedSites, selectedRegions,
            selectedGeographicRegions, selectedGeographicLocalities, selectedStatuses,
            selectedArchived, selectedAssetType, selectedKpiCustomer, selectedKeyCustomer,
            fromDate, toDate, sortByColumn, sortDirection
          );
          if(mounted){
              if (response !== null && response !== undefined) {
                  //console.log('data fetched',response);
                  setIsLoading(false);
                  setData(response.retests === null || response.retests === undefined ? [] : response.retests);
                  setCount(response.total_retests);

                  if (response.total_retests < page * rowsPerPage) {
                      setPage(0);
                      localStorage.setItem('retests_page', 0);
                  }

              }
              else {
                //console.log('no data fetched',response);
                  setIsLoading(false);
              }
          }

     };

     const fetchRetestSites = async() => {
         var isSelectedCustomerCacheAvailable = localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
             JSON.parse(localStorage.getItem('retests_filter_list'))[1] !== undefined &&
             JSON.parse(localStorage.getItem('retests_filter_list'))[1] !== null;
         var selectedCustomersToUse = selectedCustomers.length > 0 ? selectedCustomers : (isSelectedCustomerCacheAvailable ? JSON.parse(localStorage.getItem('retests_filter_list'))[1] : []);
         const response = await ttAPI.getRetestSites(selectedStatuses, selectedArchived, selectedCustomersToUse);
         //if(mounted){
             if (response !== null && response !== undefined) {
                 setSitesFilterOptions(response);
                 // load selection from cache
                 if (localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[2] !== undefined &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[2] !== null) {
                       var cachedList = JSON.parse(localStorage.getItem('retests_filter_list'))[2];
                       setSelectedSites(cachedList);
                       setCachedSelectedSites(
                           response.filter(option => cachedList.filter(value => value === option.site_id).length > 0));
                           //console.log('tttt?????',response.filter(option => cachedList.filter(value => value === option.site_id).length > 0))
                 }
             }
         //}
     }


     const fetchRetestCustomers = async() => {
         const response = await ttAPI.getRetestCustomers(selectedStatuses,selectedArchived);
         if(mounted){
             if (response !== null && response !== undefined) {
                 setCustomersFilterOptions(response);

                 if (selectedCustomers !== null && selectedCustomers !== undefined &&
                     selectedCustomers.length > 0) {
                    fetchRetestSites();
                 }
                 else {
                     // load selection from cache
                     if (localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
                         JSON.parse(localStorage.getItem('retests_filter_list'))[1] !== undefined &&
                         JSON.parse(localStorage.getItem('retests_filter_list'))[1] !== null) {
                           var cachedList = JSON.parse(localStorage.getItem('retests_filter_list'))[1];
                           setSelectedCustomers(cachedList);
                           setCachedSelectedCustomers(
                               response.filter(option => cachedList.filter(value => value === option.customer_id).length > 0));
                           if (cachedList !== null && cachedList !== undefined &&
                               cachedList.length > 0) {
                              fetchRetestSites();
                           }
                     }
                 }
             }
         }
     }

     const fetchRetestGeoLocalities = async() => {
         const response = await ttAPI.getRetestGeoLocalities();
         if(mounted){
             if (response !== null && response !== undefined) {
                 setGeoLocalitiesFilterOptions(response);
                 fetchRetestCustomers();

                 if (localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[11] !== undefined &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[11] !== null) {
                       var cachedList = JSON.parse(localStorage.getItem('retests_filter_list'))[11];
                       setSelectedGeographicLocalities(cachedList.map(value => `'${value}'`));
                       setCachedSelectedGeographicLocalities(
                           response.filter(option => cachedList.filter(value => value === option.site_geo_locality).length > 0));
                 }
             }
         }
     }

     const fetchRetestGeoRegions = async() => {
         const response = await ttAPI.getRetestGeoRegions();
         if(mounted){
             if (response !== null && response !== undefined) {
                 setGeoRegionsFilterOptions(response);
                 fetchRetestGeoLocalities();

                 if (localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[10] !== undefined &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[10] !== null) {
                       var cachedList = JSON.parse(localStorage.getItem('retests_filter_list'))[10];
                       setSelectedGeographicRegions(cachedList);
                       setCachedSelectedGeographicRegions(
                           response.filter(option => cachedList.filter(value => value === option.id).length > 0));
                 }
             }
         }
     }

     const fetchRetestRegions = async() => {
         const response = await ttAPI.getRegions();
         if(mounted){
             if (response !== null && response !== undefined) {
                 setRetestRegionsOptions(response);
                 fetchRetestGeoRegions();

                 if (localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[9] !== undefined &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[9] !== null) {
                       var cachedList = JSON.parse(localStorage.getItem('retests_filter_list'))[9];
                       setSelectedRegions(cachedList);
                       setCachedSelectedRetestRegions(
                           response.filter(option => cachedList.filter(value => value === option.id).length > 0));
                 }
             }
         }
      }


      //console.log('about to fetch data',key, offset, rowsPerPage, selectedCustomers, selectedSites, selectedRegions, selectedGeographicRegions, selectedGeographicLocalities, selectedBooked, selectedArchived, from, to, sortByColumn, sortDirection);
      //console.log('test key, isLoading ', key, isLoading, ((key === null || key === undefined || key === '') || (key !== null && key !== undefined && key.length >=3 )));
      if (/*!isLoading && */((key === null || key === undefined || key === '') || (key !== null && key !== undefined && key.length >=3 ))) {
        fetchData();
      }


      if (retestRegionsOptions === null || retestRegionsOptions === undefined || retestRegionsOptions.length <= 0) {
          fetchRetestRegions();
      }
      if (geoRegionsFilterOptions === null || geoRegionsFilterOptions === undefined || geoRegionsFilterOptions.length <= 0) {
          fetchRetestGeoRegions();
      }

      if (geoLocalitiesFilterOptions === null || geoLocalitiesFilterOptions === undefined || geoLocalitiesFilterOptions.length <= 0) {
          fetchRetestGeoLocalities();
      }

      if (customersFilterOptions === null || customersFilterOptions === undefined || customersFilterOptions.length <= 0
           || customersSelectionUpdated) {
          setCustomersSelectionUpdated(false);
          fetchRetestCustomers();
      }
      else {
          if (selectedCustomers.length > 0 &&
              (sitesFilterOptions === null || sitesFilterOptions === undefined || sitesFilterOptions.length <= 0 ||
               sitesSelectionUpdated)) {
              setSitesSelectionUpdated(false);
              fetchRetestSites();
          }
      }


     return () => mounted = false;

  }, [key, offset, rowsPerPage, selectedCustomers, selectedSites,
      selectedRegions, selectedGeographicRegions, selectedGeographicLocalities,
      selectedStatuses, selectedArchived, selectedAssetType, selectedKpiCustomer, selectedKeyCustomer,
      from, to, sortByColumn, sortDirection]);

  async function onSearchKey(key) {
      setKey(key);
  };

  function setupFromAndToForFilter(filters) {
    var fromDate;
    var toDate;
    if (filters !== undefined && filters !== null) {
      if (filters[1] !== undefined && filters[2] !== undefined && filters[1] !== null && filters[2] !== null) {
        fromDate = new Date(filters[1]);
        toDate = new Date(filters[2]);
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
        toDate = new Date(toDate.getFullYear(), toDate.getMonth() + 1, 0);
        setIsRange(true);
      }
      else {
        fromDate = new Date(filters[1]);
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
        toDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0);
        setIsRange(false);
      }
      //console.log(fromDate);
      setFrom(fromDate);
      setTo(toDate);
      //console.log('setupFromAndToForFilter', fromDate, toDate);
    }
  }

  function getDefaultFrom() {
    return new Date((new Date()).getFullYear(), (new Date()).getMonth() - 1, 1);
  }

  function getDefaultTo() {
    var date;
    if ((new Date()).getMonth() == 11) {
        date = new Date((new Date()).getFullYear() + 1, 0, 31);
    } else {
        date = new Date((new Date()).getFullYear(), (new Date()).getMonth() + 2, 0);
    }
    return date;
  }
  function getDefaultFromFilter() {
    var date = getDefaultFrom();
    return months[date.getMonth()] + ' ' + date.getFullYear();
  }

  function getDefaultToFilter() {
    var date = getDefaultTo();
    return months[date.getMonth()] + ' ' + date.getFullYear();
  }

  function validateCalendarOnChange(start, finish) {
     var isEmpty = isRange ? start === undefined || start === null || finish === undefined || finish === null : start === undefined || start === null;
    setIsTimeRangeInvalid(isEmpty || start >= finish);
  }

    useEffect(() => {
        if (props.location.state !== undefined && props.location.state.jobId !== undefined) {
            sendNotification('success', `Success - Job ${props.location.state.jobId} Booked.`, classes);
        }
    },[props.location.state, sendNotification]);

    async function changePage(p, rpp) {
      setPage(p);
      setOffset(p * rpp);
      setIsLoading(true);
    }

 function onSelectRetestRegions(values) {
     setSelectedRegions(values.map(({ id }) => id));
     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
     filterList[9] = values.map(({ id }) => id);
     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
 }

 function onSelectRetestStatus(values) {
     setSelectedStatuses(values.map(({ id }) => id));
     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
     filterList[13] = values.map(({ id }) => id);
     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
 }

 function onSelectGeographicRegions(values) {
     setSelectedGeographicRegions(values.map(({ id }) => id));
     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
     filterList[10] = values.map(({ id }) => id);
     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
 }

 function onSelectGeographicLocalities(values) {
     setSelectedGeographicLocalities(values.map(({ site_geo_locality }) => `'${site_geo_locality}'`));
     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
     filterList[11] = values.map(({ site_geo_locality }) => site_geo_locality);
     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
 }

 function onSelectCustomers(values) {
     setSelectedCustomers(values.map(({ customer_id }) => customer_id));
     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
     filterList[1] = values.map(({ customer_id }) => customer_id);
     if (filterList[1] === undefined || filterList[1] === null || filterList[1].length === 0) {
         // reset selected site if no customer is selected
         filterList[2] = [];
         setSelectedSites([]);
     }
     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
     setCustomersSelectionUpdated(true);
 }

 function onSelectSites(values) {
     setSelectedSites(values.map(({ site_id }) => site_id));
     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
     filterList[2] = values.map(({ site_id }) => site_id);
     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
     setSitesSelectionUpdated(true);
 }

 const handleClick = (event) => {
   setAnchorEl(event.currentTarget);
   setIsMenuOpen(true);
 };

 const handleClose = () => {
   setAnchorEl(null);
   setSelectedRowIndex(-1);
   setIsMenuOpen(false);
 };

 const openSendEmail = async () => {
     const emails = await ttAPI.getJobWorkerEmails( data[selectedRowIndex].id);
     window.location.href = `mailto:${data[selectedRowIndex].site_email}?subject=Follow Up : Electrical Retesting Reminder - ${data[selectedRowIndex].expiry_month}`;
     handleClose();
 }

 const onCellClick = (dataIndex, colIndex) => {
   console.log('onCellClick ',isEditingNotes, isEditingStatus, colIndex)
    setSelectedRowIndex(dataIndex);
    console.log('set selected row index to ', selectedRowIndex == dataIndex ? -1 : dataIndex);

    if (!isMenuOpen) {
      if (colIndex !== 8 && colIndex !== 18 && colIndex !== 12 && colIndex !== 13 && colIndex !== 14) { // index 16 is the menu
        window.open(
            `${config.adminApi}/#/app/retest/book/${data[dataIndex].id}`,
            '_blank'
        );
      }
    }
 }

 const onNotesCellClick = (dataIndex, colIndex, isSelected) => {
   console.log('onNotesCellClick ')
    setSelectedRowIndex((!isSelected && selectedRowIndex == dataIndex) ? -1 : dataIndex);
 }

 const onStatusCellClick = (dataIndex, colIndex, isSelected) => {
   console.log('onStatusCellClick ')
    setSelectedRowIndex((!isSelected && selectedRowIndex == dataIndex) ? -1 : dataIndex);
 }

 const onRemindedCellClick = (dataIndex, colIndex, isSelected) => {
   console.log('onRemindedCellClick ')
    setSelectedRowIndex((!isSelected && selectedRowIndex == dataIndex) ? -1 : dataIndex);
 }

 async function handleSubmit (retestToUpdate) {
      console.log('handleSubmit', retestToUpdate);

      const response = await ttAPI.saveRetest(retestToUpdate);

      if (response !== undefined && response.data !== undefined &&
          response.data[0] !== undefined) {
            if (response.data[0].ok) {
              sendNotification('success', `Success - Retest ${retestToUpdate.id} Updated Successfully.`, classes);
            }
            else {
              sendNotification('error', `Failed to update Retest ${retestToUpdate.id}`, classes);
            }
      }
  }

  const getStatusCategory = (statusName) => {
      var status = retestStatusOptions.find(status => statusName === status.name);
      return status === undefined ? '' : status.category_name;
  }

  const showTODOList = () => {
    if (localStorage.getItem('retests_filter_list') !== undefined && localStorage.getItem('retests_filter_list') !== null &&
        JSON.parse(localStorage.getItem('retests_filter_list'))[13] !== undefined &&
        JSON.parse(localStorage.getItem('retests_filter_list'))[13] !== null) {
          var newCachedList = [1,2,3,4,5,6,7,8];
          setSelectedStatuses(newCachedList);
          setCachedSelectedRetestStatuses(
              retestStatusOptions.filter(option => newCachedList.filter(value => value === option.id).length > 0));
          var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
          filterList[13] = newCachedList;
          localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
          // the multiselect component is not a controlled component, just refresh the page for now
          //window.location.reload();
    }
  }

 /*const handleMouseDownSearch = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  function handleClickSearch() {console.log('handleClickSearch',document.getElementById('standard-adornment-search').value)
     setKey( document.getElementById('standard-adornment-search').value )
  }

 const searchInput = useMemo(() => {
   return (
    <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
            <InputLabel htmlFor="standard-adornment-search">Search contact, phone, email</InputLabel>
            <Input
              id="standard-adornment-search"
              type="text"

              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickSearch}
                    onMouseDown={handleMouseDownSearch}
                  >
                    <SearchIcon/>
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>);
 });*/

  async function downloadRetestSheet() {

       var fromDate = null;
       var toDate = null;

       if (from !== undefined && from !== null && !isNaN(from.getTime())) {
           var [date, month, year] = from.toLocaleDateString('en-NZ').split("/");
           fromDate = `${year}-${month}-${date}`;
       }

       if (to !== undefined && to !== null && !isNaN(to.getTime())) {
           var [date, month, year] = to.toLocaleDateString('en-NZ').split("/");
           toDate = `${year}-${month}-${date}`;
       }
       await ttAPI.downloadRetestsSheet(key, offset, rowsPerPage, selectedCustomers, selectedSites, selectedRegions, selectedGeographicRegions, selectedGeographicLocalities, selectedStatuses, selectedArchived, selectedAssetType, selectedKpiCustomer, selectedKeyCustomer, fromDate, toDate, sortByColumn, sortDirection);

   }

   function handleChangeSelectAssetType(e) {
     setSelectedAssetType(e.target.value);
     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
     filterList[17] = e.target.value;
     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
   }


  return (
    <>
      <PageTitle title="Retests"/>
      <Grid container spacing={4}>
      <Grid item xs={12}>


      <div className="retest_range_filter">
        <FormGroup row className={classes.searchRow}>
              <div style={{display:'inline-flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', justifyContent: 'space-between'}}>
            <Box style={{ display: 'flex', alignItems: 'flex-end' }}>
              <SearchIcon/>
              <TextField id="input-search" variant="standard" style={{minWidth: '370px'}}
                         label="Search customer/site name, contact, phone, email"
                         onChange={(e) => {delayedOnSearchKey(e.target.value); localStorage.setItem('retests_search_text', e.target.value);}}
                         InputProps={{
                         endAdornment: <InputAdornment position="end">
                                          <IconButton
                                            aria-label="clear search"
                                            onClick={() => {setKey(''); localStorage.setItem('retests_search_text', '');}}
                                            onMouseDown={(e) => e.preventDefault()}
                                          >
                                          {key !== null && key !== undefined && key.length > 0 ? <ClearIcon /> : null}
                                          </IconButton>
                                        </InputAdornment>,
                       }}/>
             </Box>




          {/*<div style={{display:'inline-flex', alignItems:'center'}}>*/}
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <MaterialDatePicker
                    className={classes.from}
                    views={["year", "month"]}
                    openTo="month"
                    variant="inline"
                    label={isRange ? 'Expires From' : 'Expires In'}
                    value={from || null}
                    error={isTimeRangeInvalid}
                    onChange={date => {
                      var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                      var index = 3; // index of expiry month
                      filterList[index][1] = months[date.getMonth()] + ' ' + date.getFullYear();
                      setupFromAndToForFilter(filterList[index]);
                      validateCalendarOnChange(date, filterList[index][2] === undefined || filterList[index][2] === null || filterList[index][2] === ''? undefined : new Date(filterList[index][2]));
                      localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                    }}
                    onError={console.log}
                    format="MMM yyyy"
                  />
              </MuiPickersUtilsProvider>
              {isRange && (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <MaterialDatePicker
                     className={classes.to}
                     views={["year", "month"]}
                     openTo="month"
                     variant="inline"
                      label="Expires To"
                      value={to || null}
                      onChange={date => {
                        var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                        var index = 3; // index of expiry month
                        filterList[index][2] = months[date.getMonth()] + ' ' + date.getFullYear();
                        setupFromAndToForFilter(filterList[index]);
                        validateCalendarOnChange(filterList[index][1] === undefined || filterList[index][1] === null || filterList[index][1] === ''? undefined : new Date(filterList[index][1]), date);
                        localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                      }}
                      onError={(error, value) => {if (error !== '') {setIsTimeRangeInvalid(true);}}}
                      minDate={from || ''}
                      minDateMessage="Finish time cannot be earlier than start time"
                      format="MMM yyyy"
                    />
                </MuiPickersUtilsProvider>
              )}

              {/*<FormLabel>Expiry Date</FormLabel>*/}
              <FormControlLabel
                  control={
                      <Switch
                          checked={isRange || false}
                          name="isRange"
                          color="primary"
                          onChange={event => {
                            var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                            var index = 3; // index of expiry month

                            //setIsRange(event.target.checked);
                            filterList[index][0] = String(event.target.checked);
                            if (!event.target.checked) {
                              filterList[index][2] = null;
                            }
                            else {
                              //console.log('test',months[to.getMonth()] + ' ' + to.getFullYear());
                              filterList[index][2] = months[to.getMonth()] + ' ' + to.getFullYear();
                            }
                            setupFromAndToForFilter(filterList[index]);
                            localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                            //onChange(filterList[index], index, column);
                          }
                          }
                      />
                  }
                  label="Range"
              />
          {/*</div>
          <div style={{ display: 'inline-flex', justifyContent:'flex-end', alignItems:'center'}}>*/}
          {retestStatusOptions !== null && retestStatusOptions !== undefined &&
              retestStatusOptions.length > 0 && cachedSelectedRetestStatuses != null &&
              <div style={{width: 'auto', minWidth: '350px', maxWidth: '700px'}}>
          <MultiSelectAutoComplete  presetValue={cachedSelectedRetestStatuses}
                                 value={cachedSelectedRetestStatuses}
                                 options={retestStatusOptions}
                                 groupByName="category_name"
                                 label="Status"
                                 idName="status"
                                 displayName="name"
                                 menuHeight="800px"
                                 onSelect={onSelectRetestStatus}
                                 renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                      <Chip
                                        classes={{
                                          root: classnames(classes.tag, {
                                            [classes.done]: option.category_name === 'Done',
                                            [classes.inProgress]: option.category_name === 'In Progress' && option.name !== 'NEW',
                                            [classes.actionRequired]: option.category_name === 'Action Required',
                                            [classes.onhold]: option.category_name === 'On-hold',
                                            [classes.archived]: option.category_name === 'Archived'
                                          })
                                        }}
                                        size="small"
                                        label={`${option.name}`}
                                        {...getTagProps({ index })}
                                      />
                                    ))
                                  }
                                 renderOption={(props, option) => {
                                    return (
                                      <span title={props.description}
                                      className={classnames({
                                      [classes.doneText]: props.category_name === 'Done',
                                      [classes.inProgressText]: props.category_name === 'In Progress' && props.name !== 'NEW',
                                      [classes.actionRequiredText]: props.category_name === 'Action Required',
                                      [classes.onholdText]: props.category_name === 'On-hold',
                                      [classes.archivedText]: props.category_name === 'Archived',
                                      [classes.archivedTextStrikeThrough]: props.category_name === 'On-hold' && props.name === 'CLOSED/NO NEED'})}>
                                        {props.name}

                                      </span>
                                    );
                                  }}
                                 /></div>
                               }
          {/*</div>
          <div style={{ width: '125px', display: 'inline-flex', justifyContent:'space-between', alignItems:'center'}}>*/}
              {retestStatusOptions !== null && retestStatusOptions !== undefined
                && retestStatusOptions.length > 0
                && cachedSelectedRetestStatuses != null
                && <Button onClick={showTODOList}>TODO</Button>}
                  <FormControlLabel
                      control={
                          <Switch
                              checked={selectedArchived}
                              name="isArchived"
                              color="primary"
                              onChange={event => {
                                setSelectedArchived(event.target.checked);
                                var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                                var index = 16; // index of archived
                                filterList[index][0] = String(event.target.checked);
                                localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                              }
                              }
                          />
                      }
                      label="Archived"
                  />
          </div>
          </FormGroup>

          <FormGroup row className={classes.searchRow} style={{marginBottom: '20px'}}>
          {retestRegionsOptions !== null && retestRegionsOptions !== undefined &&
              retestRegionsOptions.length > 0 && cachedSelectedRetestRegions != null &&
              <div>
                <MultiSelectAutoComplete  presetValue={cachedSelectedRetestRegions}
                                       options={retestRegionsOptions}
                                       label="Scheduling Zones/Regions"
                                       idName="id"
                                       displayName="name"
                                       onSelect={onSelectRetestRegions}/>
              </div>}

              {geoRegionsFilterOptions !== null && geoRegionsFilterOptions !== undefined &&
                  geoRegionsFilterOptions.length > 0 && cachedSelectedGeographicRegions != null &&
              <div>
                <MultiSelectAutoComplete  presetValue={cachedSelectedGeographicRegions}
                                       options={geoRegionsFilterOptions}
                                       label="Geo Regions"
                                       idName="id"
                                       displayName="site_geo_region_name"
                                       onSelect={onSelectGeographicRegions}/>
              </div>}

              {geoLocalitiesFilterOptions !== null && geoLocalitiesFilterOptions !== undefined &&
                  geoLocalitiesFilterOptions.length > 0 && cachedSelectedGeographicLocalities !== null &&
              <div>
                <MultiSelectAutoComplete  presetValue={cachedSelectedGeographicLocalities}
                                       options={geoLocalitiesFilterOptions}
                                       label="Geo Localities"
                                       displayName="site_geo_locality"
                                       onSelect={onSelectGeographicLocalities}/>
              </div>}



          </FormGroup>

          <FormGroup row className={classes.searchRow} style={{marginBottom: '20px'}}>
          {customersFilterOptions !== null && customersFilterOptions !== undefined &&
              customersFilterOptions.length > 0 && cachedSelectedCustomers !== null &&
              <div style={{ display: 'flex', flexDirection: 'column', minWidth: '420px' }}>
                <MultiSelectAutoComplete
                  presetValue={cachedSelectedCustomers}
                  options={customersFilterOptions}
                  label="Customers"
                  displayId="customer_id"
                  displayName="customer_name"
                  onSelect={onSelectCustomers}
                />

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    marginTop: '-2px',
                    marginLeft: '8px'
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={selectedKpiCustomer}
                        name="isKpiCustomer"
                        color="primary"
                        onChange={event => {
                          setSelectedKpiCustomer(event.target.checked);
                          var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                          filterList[18] = [String(event.target.checked)];
                          localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                        }}
                      />
                    }
                    label="KPI"
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        checked={selectedKeyCustomer}
                        name="isKeyCustomer"
                        color="primary"
                        onChange={event => {
                          setSelectedKeyCustomer(event.target.checked);
                          var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                          filterList[19] = [String(event.target.checked)];
                          localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                        }}
                      />
                    }
                    label="Key"
                  />
                </div>
              </div>}

              {selectedCustomers !== null && selectedCustomers !== undefined &&
                  selectedCustomers.length > 0 &&
                  sitesFilterOptions !== null && sitesFilterOptions !== undefined &&
                  sitesFilterOptions.length > 0 && cachedSelectedSites !== null &&
                <div>
                    <MultiSelectAutoComplete  presetValue={cachedSelectedSites}
                                       options={sitesFilterOptions}
                                       label="Sites"
                                       displayId="site_id"
                                       displayName="site_name"
                                       onSelect={onSelectSites}/>
              </div>}

              {selectedAssetType !== null && selectedAssetType !== undefined &&
                  /*assetTypeFilterOptions !== null && assetTypeFilterOptions !== undefined &&
                  assetTypeFilterOptions.length > 0 && cachedSelectedAssetType !== null && */
                  <div className={classes.assetType}>
                      <FormControl variant="outlined" className={classnames({
                            'assetTypeSelect':  true,
                            'asset-type-select-control': true
                          })}>
                        <InputLabel id="asset_type_select">Asset Type</InputLabel>
                        <div className={classnames({
                                      'select-control-input': true
                                    })}>
                          <NativeSelect
                            value={selectedAssetType}
                            onChange={handleChangeSelectAssetType}
                          >
                             <option value="ALL">ALL</option>
                             <option value="GENERAL">GENERAL</option>
                             <option value="AED">AED</option>
                             <option value="EVSE">EVSE</option>
                             <option value="THERMAL">THERMAL</option>
                             <option value="TELTAG">TELTAG</option>
                          </NativeSelect>
                        </div>

                      </FormControl>
                  </div>}

          </FormGroup>

          </div>

        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            className="retest_list_table"
            data={data !== undefined ? data.map(item => {
                return [
                    item.id, // 0
                    item.customer_name, // 1
                    item.site_name, // 2
                    item.expiry_month, // 3
                    item.last_tested, // 4
                    item.site_contact, // 5
                    item.site_phone, // 6
                    item.site_email, // 7
                    item.email_total_assets ?? item.site_total_assets, // 8
                    item.region_name, // 9
                    item.site_geo_region_name, // 10
                    item.site_geo_locality, // 11
                    item.notes, //12
                    item.status, //13
                    item.date_reminded, //14
                    item.archived ? 'YES' : 'NO',//15
                    item.kpi_customer ? 'YES' : 'NO', // 16
                    item.key_customer ? 'YES' : 'NO', // 17
                    `${config.adminApi}/#/app/retest/book/${item.id}`,//18
                    item.asset_type,//19

                ]
            }) : []}
            columns={columns}
            options={{
              fixedHeader: true,
              tableBodyHeight: '70vh',
              filter: true,
              serverSide: true,
              print: false,
              viewColumns: false,
              search: false,
              filter: false,
              print: false,
              download: false,
              /*onDownload: async (buildHead, buildBody, columns, data) => {
                var fromDate = null;
                var toDate = null;

                if (from !== undefined && from !== null && !isNaN(from.getTime())) {
                    var [date, month, year] = from.toLocaleDateString('en-NZ').split("/");
                    fromDate = `${year}-${month}-${date}`;
                }

                if (to !== undefined && to !== null && !isNaN(to.getTime())) {
                    var [date, month, year] = to.toLocaleDateString('en-NZ').split("/");
                    toDate = `${year}-${month}-${date}`;
                }
                await ttAPI.downloadRetestsSheet(key, offset, rowsPerPage, selectedCustomers, selectedSites, selectedRegions, selectedGeographicRegions, selectedGeographicLocalities, selectedStatuses, selectedArchived, fromDate, toDate, sortByColumn, sortDirection);
                return false;
              },*/
              customToolbar: () => {
                return (
                   <Tooltip title="Download as Spreadsheet">
                    <IconButton onClick={downloadRetestSheet}><CloudDownloadIcon /></IconButton>
                    </Tooltip>
                );
              },
              selectableRows: 'single',
              selectableRowsOnClick: true,
              selectableRowsHideCheckboxes: true,
              /*customToolbar: (displayData) => {return null;},
              customToolbarSelect: (selectedRows, displayData, setSelectedRows)  => {return null;},*/
              selectableRowsHeader: false,
              rowsPerPageOptions: [10,15,20,50,100,500, 1000],
              count: count,
              page: page,
              rowsPerPage: rowsPerPage,
              onChangeRowsPerPage: (numberOfRows) => {
                  setRowsPerPage(numberOfRows);
                  localStorage.setItem('retests_rows_per_page', numberOfRows);
              },
              onColumnSortChange: (changedColumn, direction) => {
                  setSortByColumn(changedColumn);
                  setSortDirection(direction);
              },
              //customSearchRender: debounceSearchRender(500, localStorage.getItem('retests_search_text')),
              textLabels: {
                    body: { noMatch: isLoading ? <CircularProgress size={25} color={'inherit'} /> : 'Sorry, no matching records found.' } ,
                    //toolbar: { downloadCsv: "Download Workload Report"}
              },
              downloadOptions: {filterOptions:{useDisplayedColumnsOnly: false, useDisplayedRowsOnly: false}},
              /*onDownload: (buildHead, buildBody, columns, data) => {
                 window.open(
                     `${config.adminApi}/#/app/reports`,
                     '_blank'
                     );
                    return false;
              },*/

              /*onRowClick: row => {
                    window.open(
                            `${config.adminApi}/#/app/retest/book/${row[0]}`,
                            '_blank'
                          );
                //history.push({pathname:`/app/retest/book/${row[0]}`,state:{retestId: row[0]}})

              },*/
              onTableInit: (action, tableState) => {
                  console.log('onTableInit')
                  // setup date range first
                  if (localStorage.getItem('retests_filter_list') === undefined || localStorage.getItem('retests_filter_list') === null) {
                       localStorage.setItem('retests_filter_list', JSON.stringify(Array(20).fill([])));
                  }
                  else {
                    if (JSON.parse(localStorage.getItem('retests_filter_list'))[3] !== undefined && JSON.parse(localStorage.getItem('retests_filter_list'))[3] !== null) {
                        if (JSON.parse(localStorage.getItem('retests_filter_list'))[3].length == 0) {
                            var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                            var index = 3; // index of expiry month
                            filterList[index][0] = 'false';
                            filterList[index][1] = getDefaultFromFilter();
                            setIsRange(false);
                            //setFrom(getDefaultFrom());
                            //setTo(getDefaultTo());
                            setupFromAndToForFilter(filterList);
                            localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                        }
                        else if (JSON.parse(localStorage.getItem('retests_filter_list'))[3].length > 0) {
                            setupFromAndToForFilter(JSON.parse(localStorage.getItem('retests_filter_list'))[3]);
                        }
                    }

                    // if there is a cached selectedSite but no selectedCustomer, clear it
                    if (JSON.parse(localStorage.getItem('retests_filter_list'))[2] !== undefined && JSON.parse(localStorage.getItem('retests_filter_list'))[2] !== null && JSON.parse(localStorage.getItem('retests_filter_list'))[2].length >= 1 &&
                        (JSON.parse(localStorage.getItem('retests_filter_list'))[1] === undefined || JSON.parse(localStorage.getItem('retests_filter_list'))[1] === null || JSON.parse(localStorage.getItem('retests_filter_list'))[1].length === 0)) {
                            var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                            filterList[2] = [];
                            localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                            setSelectedSites([]);

                    }
                  }

                  if(JSON.parse(localStorage.getItem('retests_filter_list'))[15] !== undefined &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[15] !== null) {
                     setSelectedArchived(JSON.parse(localStorage.getItem('retests_filter_list'))[15][0] === 'true');
                  }

                  if(JSON.parse(localStorage.getItem('retests_filter_list'))[17] !== undefined &&
                     JSON.parse(localStorage.getItem('retests_filter_list'))[17] !== null) {
                     setSelectedAssetType(JSON.parse(localStorage.getItem('retests_filter_list'))[17]);
                     //setCachedSelectedAssetType(localStorage.getItem('retests_filter_list'))[17]);
                  }
                  else {
                     setSelectedAssetType('ALL');
                     //setCachedSelectedAssetType('ALL');
                     var filterList = JSON.parse(localStorage.getItem('retests_filter_list'));
                     filterList[17] = 'ALL';
                     localStorage.setItem('retests_filter_list', JSON.stringify(filterList));
                  }

                  if (JSON.parse(localStorage.getItem('retests_filter_list'))[18] !== undefined &&
                      JSON.parse(localStorage.getItem('retests_filter_list'))[18] !== null &&
                      JSON.parse(localStorage.getItem('retests_filter_list'))[18].length > 0) {
                      setSelectedKpiCustomer(JSON.parse(localStorage.getItem('retests_filter_list'))[18][0] === 'true');
                  }

                  if (JSON.parse(localStorage.getItem('retests_filter_list'))[19] !== undefined &&
                      JSON.parse(localStorage.getItem('retests_filter_list'))[19] !== null &&
                      JSON.parse(localStorage.getItem('retests_filter_list'))[19].length > 0) {
                      setSelectedKeyCustomer(JSON.parse(localStorage.getItem('retests_filter_list'))[19][0] === 'true');
                  }


                  if (localStorage.getItem('retests_search_text') !== undefined && localStorage.getItem('retests_search_text') !== null) {
                     if (localStorage.getItem('retests_search_text') !== 'null' && localStorage.getItem('retests_search_text') !== 'undefined') {
                       setKey(localStorage.getItem('retests_search_text'));
                       document.getElementById('input-search').value = localStorage.getItem('retests_search_text');
                     }
                  }

                  if (localStorage.getItem('retests_page') !== undefined && localStorage.getItem('retests_page') !== null) {
                    if (localStorage.getItem('retests_page') !== 'null' && localStorage.getItem('retests_page') !== 'undefined') {
                        tableState.page = parseInt(localStorage.getItem('retests_page'));
                        setPage(parseInt(localStorage.getItem('retests_page')));
                        setOffset(parseInt(localStorage.getItem('retests_page')) * parseInt(localStorage.getItem('retests_rows_per_page')));
                    }
                  }

                  if (localStorage.getItem('retests_rows_per_page') !== undefined && localStorage.getItem('retests_rows_per_page') !== null &&
                      localStorage.getItem('retests_page') !== 'null' && localStorage.getItem('retests_page') !== 'undefined' &&
                      localStorage.getItem('retests_rows_per_page') >= 10) {
                        tableState.rowsPerPage = parseInt(localStorage.getItem('retests_rows_per_page'));
                        setRowsPerPage(parseInt(localStorage.getItem('retests_rows_per_page')));
                  }
                  else {
                    tableState.rowsPerPage = 100;
                  }

              },
              onChangePage:(currentPage) => {
                setPage(currentPage);
                localStorage.setItem('retests_page', currentPage);
              },
              onSearchChange: (searchText) => {
                localStorage.setItem('retests_search_text', searchText);
              },
              onTableChange: (action, tableState) => {
                //console.log(action);
                //console.log( tableState);
                switch (action) {
                  case "changePage":
                    changePage(tableState.page, tableState.rowsPerPage);
                    break;
                  case "changeRowsPerPage":
                    changePage(tableState.page, tableState.rowsPerPage);
                    break;
                }
              },
              setRowProps: (row, dataIndex, rowIndex) => {
                  return {
                    className: classnames({
                        [classes.strike]: data[dataIndex].archived,
                        [classes.selectedBorder]: isEditingNotes && rowIndex === selectedRowIndex
                      }),
                  };

              },
              /*onCellClick: (colData, cellMeta) => {console.log('onCellClick here?',cellMeta);
                //{ colIndex: number, rowIndex: number, dataIndex: number }
                setSelectedRowIndex(cellMeta.dataIndex);setIsEditingNotes(true);
                if (cellMeta.colIndex === 12 && !isEditingNotes) {
                  setIsEditingNotes(true);
                }
                if (!isMenuOpen) {
                  if (cellMeta.colIndex !== 18 && cellMeta.colIndex !== 12 && cellMeta.colIndex !== 13) { // index 18 is the menu
                    window.open(
                        `${config.adminApi}/#/app/retest/book/${data[cellMeta.dataIndex].id}`,
                        '_blank'
                    );
                  }
                }

              },*/

              customRowRender: (rowData, dataIndex, rowIndex) => {
                     return  (
                        <TableRow key={rowData[0]} id={rowIndex}
                                  className={classnames({
                                  [classes.strike]: rowData[15] === 'YES',
                                  [classes.selectedBackgroundColour]: selectedRowIndex === rowIndex,
                                  [classes.done]: getStatusCategory(data[rowIndex].status) === 'Done',
                                  [classes.inProgress]: getStatusCategory(data[rowIndex].status) === 'In Progress' && data[rowIndex].status !== 'NEW',
                                  [classes.actionRequired]: getStatusCategory(data[rowIndex].status) === 'Action Required',
                                  [classes.onhold]: getStatusCategory(data[rowIndex].status) === 'On-hold',
                                  [classes.archived]: getStatusCategory(data[rowIndex].status) === 'Archived'
                                })}>
                            <TableCell onClick={() => onCellClick(dataIndex, 1)}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  {rowData[17] === 'YES' && (
                                    <Tooltip title="Key customer">
                                      <VpnKeyIcon style={{ fontSize: 18, color: '#d4a017' }} />
                                    </Tooltip>
                                  )}
                                  {rowData[16] === 'YES' && (
                                    <Tooltip title="KPI customer">
                                      <TrackChangesIcon style={{ fontSize: 18, color: '#d4a017' }} />
                                    </Tooltip>
                                  )}
                                  <span>{rowData[1]}</span>
                                </div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 2)}>
                                 <div>{rowData[2]}</div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 3)}>
                                 <div>{rowData[3]}</div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 4)}>
                                 <div>{rowData[4]}</div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 5)}>
                                 <div>{rowData[5]}</div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 6)}>
                                 <div>{rowData[6]}</div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 7)}>
                                 <div>{rowData[7]}</div>
                            </TableCell>
                            <TableCell
                                className={classnames({
                                  [classes.selectedBorder]: isEditingEmailTotalAssets && rowIndex === selectedRowIndex,
                                  [classes.noPadding]: isEditingEmailTotalAssets && rowIndex === selectedRowIndex,
                                })}
                                onClick={() => {
                                  setIsEditingEmailTotalAssets(true);
                                  setIsEditingNotes(false);
                                  setIsEditingStatus(false);
                                  setIsEditingReminded(false);
                                  setSelectedRowIndex(rowIndex);
                                }}
                              >
                                {isEditingEmailTotalAssets && rowIndex === selectedRowIndex ? (
                                  <TextField
                                    id={`email_total_assets_${rowIndex}`}
                                    name="email_total_assets"
                                    variant="standard"
                                    type="number"
                                    style={{ minWidth: '80px' }}
                                    defaultValue={data[rowIndex].email_total_assets ?? data[rowIndex].site_total_assets ?? ''}
                                    autoFocus
                                    InputProps={{
                                      disableUnderline: true,
                                    }}
                                    onBlur={event => {
                                      setIsEditingEmailTotalAssets(false);
                                      const raw = event.target.value;
                                      const parsed = parseInt(raw, 10);

                                      const value = raw === '' || isNaN(parsed) || parsed < 0
                                        ? (data[rowIndex].email_total_assets ?? data[rowIndex].site_total_assets ?? 0)
                                        : parsed;

                                      data[rowIndex].email_total_assets = value;
                                      setData([...data]);
                                      handleSubmit(data[rowIndex]);
                                    }}
                                  />
                                ) : (
                                  <div>{rowData[8]}</div>
                                )}
                              </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 9)}>
                                 <div>{rowData[9]}</div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 10)}>
                                 <div>{rowData[10]}</div>
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 11)}>
                                 <div>{rowData[11]}</div>
                            </TableCell>
                            <TableCell className={classnames({
                                                  [classes.selectedBorder]: isEditingNotes && rowIndex === selectedRowIndex,
                                                  [classes.noPadding]: isEditingNotes && rowIndex === selectedRowIndex,
                                                })}
                                       onClick={(event) => {
                                            setIsEditingNotes(true);
                                            setIsEditingEmailTotalAssets(false);
                                            setIsEditingStatus(false);
                                            setIsEditingReminded(false);
                                            onNotesCellClick(dataIndex, 12, true);
                                           }}
                                       style={{minWidth: '200px', maxWidth: '500px'}}>
                            {isEditingNotes && rowIndex === selectedRowIndex ?
                              <TextField
                                id={`notes_${rowIndex}`}
                                name="notes"
                                variant="standard"
                                type={'text'}
                                style={{minWidth: '250px'}}
                                defaultValue={rowData[12] || ''}
                                onBlur={event => {
                                  setIsEditingNotes(false);
                                  data[rowIndex].notes = event.target.value;
                                  setData(data);
                                  handleSubmit(data[rowIndex]);
                                }}

                                multiline
                                autoFocus
                                InputProps={{
                                  disableUnderline: true,
                                }}
                              />

                              :
                              (rowData[12] === undefined || rowData[12] === null || rowData[12] === '' ?
                                <div style={{lineHeight: 1.2,
                                             display: '-webkit-box',
                                             WebkitLineClamp: 3,
                                             WebkitBoxOrient: 'vertical',
                                             overflow: 'hidden',
                                             textOverflow: 'ellipsis'}}>
                                             {rowData[12]}
                                             </div>
                               :
                               <Tooltip title={rowData[12]}>
                                 <div style={{lineHeight: 1.2,
                                              display: '-webkit-box',
                                              WebkitLineClamp: 3,
                                              WebkitBoxOrient: 'vertical',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis'}}>
                                              {rowData[12]}
                                              </div>
                                </Tooltip>
                              )}
                            </TableCell>
                            <TableCell className={classnames({
                                [classes.selectedBorder]: isEditingStatus && rowIndex === selectedRowIndex,
                                [classes.noPadding]: isEditingStatus && rowIndex === selectedRowIndex,
                              })}
                             onClick={(event) => {
                                  setIsEditingStatus(true);
                                  setIsEditingEmailTotalAssets(false);
                                  setIsEditingNotes(false);
                                  setIsEditingReminded(false);
                                  onStatusCellClick(dataIndex, 13, true);
                                 }}>
                            {isEditingStatus && rowIndex === selectedRowIndex ?
                              <FormControl variant="outlined" className={classnames({
                                    'statusSelect':  true,
                                    'status-select-control': true
                                  })}
                                  tabIndex={0}
                                  onBlur={event => {console.log('onblur formcontrol of status');/*setIsEditingStatus(false);*/ }

                                }>
                                <div className={classnames({
                                              'select-control-input': true
                                            })}>
                                  {/*<NativeSelect

                                    value={data[rowIndex].status || ''}
                                    onChange={event => {
                                        setIsEditingStatus(false);
                                        data[rowIndex].status = event.target.value;
                                        setData(data);
                                        handleSubmit(data[rowIndex]);
                                    }}
                                    onBlur={event => { console.log('on blur status');

                                    }}
                                  >
                                  {allRetestStatus}


                                  </NativeSelect>*/}
                                  <Select
                                    style={{width: '100%'}}
                                    value={data[rowIndex].status || ''}
                                    onChange={event => {console.log('onChange');
                                        setIsEditingStatus(false);
                                        data[rowIndex].status = event.target.value;
                                        setData(data);
                                        handleSubmit(data[rowIndex]);
                                    }}
                                    onBlur={event => { console.log('on blur status'); setIsEditingStatus(false);
                                    }}
                                    open={statusOpen}
                                    onClose={() => {setStatusOpen(false);}}
                                    onOpen={() => {setStatusOpen(true);}}
                                  >
                                  {allRetestStatus}


                                  </Select>
                                </div>
                              </FormControl>

                              : <div>{rowData[13]}</div>}
                            </TableCell>
                            <TableCell className={classnames({
                                [classes.selectedBorder]: isEditingReminded && rowIndex === selectedRowIndex,
                                [classes.noPadding]: isEditingReminded && rowIndex === selectedRowIndex,
                              })}
                             onClick={(event) => {
                                  setIsEditingReminded(true);
                                  setIsEditingEmailTotalAssets(false);
                                  setIsEditingStatus(false);
                                  setIsEditingNotes(false)
                                  onRemindedCellClick(dataIndex, 14, true);
                                  console.log('test',data[rowIndex].date_reminded)
                                  if ((data[rowIndex].date_reminded === undefined || data[rowIndex].date_reminded === null)) {
                                    setCurrentSelectedRemindedDate(null);
                                  }

                                 }}>
                            {isEditingReminded && rowIndex === selectedRowIndex ?
                                  <TextField
                                    id={`reminded_${dataIndex}`}
                                    variant="standard"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    style={{width: '150px'}}
                                    InputProps={{
                                      startAdornment: (
                                          <InputAdornment position="start">
                                            <CalendarTodayIcon />
                                          </InputAdornment>
                                        ),
                                        inputComponent: () =>
                                          <DatePicker
                                          selected={currentSelectedRemindedDate}
                                          openToDate={(data[rowIndex].date_reminded !== undefined && data[rowIndex].date_reminded !== null)  ? new Date(data[rowIndex].date_reminded) :  new Date()}
                                          onChange={date => {
                                            var d = date !== undefined && date !== null ? new Date(date) : date;
                                            setCurrentSelectedRemindedDate(d);
                                            if (d !== undefined && d !== null) {
                                              let [date, month, year] = d.toLocaleDateString('en-NZ').split("/");
                                              data[rowIndex].date_reminded = `${year}-${month}-${date}`;
                                              if (data[rowIndex].status === 'NEW' || data[rowIndex].status === '' ||
                                                  data[rowIndex].status === null || data[rowIndex].status === undefined) {
                                                  data[rowIndex].status = 'REMINDED';
                                              }
                                              setData(data);
                                              setIsEditingReminded(false);
                                            }
                                            handleSubmit(data[rowIndex]);
                                          }}
                                          onBlur={event => setIsEditingReminded(false)}
                                          onKeyDown={(e) => e.preventDefault()}
                                          locale="en-NZ"
                                          dateFormat="dd/MM/yyyy"/>
                                      }}
                                  />

                                :  <div>{rowData[14]}</div>}
                            </TableCell>
                            <TableCell onClick={() => onCellClick(dataIndex, 18)}>
                                <div>
                                  <IconButton
                                    color="primary"
                                    component="span"
                                    onClick={(event) => {
                                    event.stopPropagation();
                                    setSelectedRowIndex(dataIndex);
                                    handleClick(event);
                                    }}
                                    >
                                    <MoreVertIcon />
                                  </IconButton>
                                </div>
                            </TableCell>
                        </TableRow>
                      );
              }
            }}
          />
          </MuiThemeProvider>
      </Grid>
      </Grid>
      {
        <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}

          >
          <StyledMenuItem
            onClick={() => {
              if (selectedRowIndex !== null && data[selectedRowIndex]) {
                nearbyJobsDialogRef.current.openNearbyJobsPopup(data[selectedRowIndex]);
              }
              handleClose();
            }}
          >
          <ListItemIcon>
            <RoomIcon fontSize="small" />
          </ListItemIcon>
            <ListItemText primary="Find Nearby Jobs" />
          </StyledMenuItem>

            <StyledMenuItem onClick={openSendEmail}>
              <ListItemIcon>
                <EmailIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Send Email" />
            </StyledMenuItem>
          </StyledMenu>

      }
      <NearbyJobsDialog ref={nearbyJobsDialogRef} />
    </>
  );
});

export default Retests;
